import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
    selector: 'rms-loading-spinner',
    templateUrl: './loading-spinner.component.html',
    styleUrls: ['./loading-spinner.component.scss'],
    standalone: false
})
export class LoadingSpinnerComponent implements OnInit {
  /**
   * When true, renders as a 14 × 12 glyph in the line of text it sits in, instead of the default
   * absolutely positioned, scaled-down loader. Opt-in: several components already restyle the
   * default, so it stays as it is.
   */
  @HostBinding('class.inline')
  @Input() inline = false;

  constructor() { }

  ngOnInit() {
  }

}
